export default __webpack_public_path__ + "static/media/arrow_blue.c5176b72.svg";